import { LinkContainer } from "./styles";

export default function LinkFormatter({ value, link }: { value: string, link: string }) {
  return (
    <LinkContainer
      href={link}
      target="_blank"
      children={value}
    />
  )
}
